// Copyright Epic Games, Inc. All Rights Reserved.

import React from "react";
import { Box, Typography, styled } from "@material-ui/core";
import { useLocMessage } from "../../store/localization/hooks";
import { InstallationAlert } from "./InstallationAlert";

const InstallationTitleInternal = styled(Typography)({
  fontWeight: "bold",
});

export const InstallationTitle = (): JSX.Element => {
  const title = useLocMessage(
    "installation.title",
    "Retrieving download metadata"
  );

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      position="relative"
    >
      <InstallationTitleInternal variant="caption">
        {title}
      </InstallationTitleInternal>
      <InstallationAlert />
    </Box>
  );
};
